import { ACCEPT_WELCOME_MESSAGE } from "./types";

export const AcceptWelcomeMessage = () => ({ type: ACCEPT_WELCOME_MESSAGE });
